module.exports = __webpack_public_path__ + "img/onlinegiving2.3c42013a.svg";